import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type FaqItem = { question: string; answer: string };

const FAQ: ReadonlyArray<FaqItem> = [
  {
    question: 'Quel est le délai de réponse ?',
    answer:
      "Moins de 24h ouvrables par email et formulaire. Moins de 30 min sur WhatsApp pendant les heures ouvrées. Sur le téléphone, un humain décroche aux heures d'ouverture.",
  },
  {
    question: 'Puis-je avoir une démo personnalisée ?',
    answer:
      'Oui. Choisis "Demande de démo" dans le formulaire — on prévoit un appel visio de 30 minutes avec ton vrai catalogue et tes vraies contraintes (multi-boutiques, stock, fiscalité locale).',
  },
  {
    question: 'Puis-je appeler directement ?',
    answer:
      'Oui, du lundi au vendredi de 8h à 18h GMT+1. Un humain décroche — pas de menu vocal interminable. Pour les clients Pro avec incident bloquant, une ligne prioritaire est disponible.',
  },
  {
    question: 'Vous répondez en français partout ?',
    answer:
      "Oui, partout et tout le temps. L'anglais est disponible sur email uniquement pour les partenaires institutionnels et la presse.",
  },
];

export default function ContactFaqV2() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Questions rapides</SectionLabel>
        <h2 className="mt-3 font-marketing-display text-[clamp(32px,4.4vw,56px)] font-bold leading-[1] tracking-[-0.035em] text-white">
          Avant de <span className="underline-lime">nous écrire.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] text-charcoal-200">
          On a regroupé les questions qu'on nous pose le plus. Si la tienne n'y est pas, envoie le
          formulaire sans hésiter.
        </p>

        <div className="mt-12 max-w-3xl">
          {FAQ.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.question}
                className={`mb-3.5 border-2 transition-colors duration-150 ${
                  isOpen ? 'border-lime-500' : 'border-charcoal-700'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-marketing-display text-[16px] font-semibold text-white"
                >
                  <span>{item.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center border-2 border-charcoal-800 bg-lime-500 text-charcoal-800">
                    {isOpen ? (
                      <Minus className="h-4 w-4" strokeWidth={3} />
                    ) : (
                      <Plus className="h-4 w-4" strokeWidth={3} />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-5 font-marketing-body text-[14px] leading-[1.65] text-charcoal-200">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
